module.exports = __webpack_public_path__ + "img/9788982733949.a73bbd72.jpg";